import { useMemo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Provider } from '@vgtv/api-client';

import { config } from '../../config';
import { Tag } from '../Tag/Tag';
import { getPath, routeNames } from '../../shared/helpers/routes';
import { RESTRICTED_TAGS } from '../../consts';
import { getSlug } from '../../shared/helpers/getSlug';

import type { SvpTag } from '../../shared/helpers/assetHelpers';
import type { VFC } from 'react';

import * as styles from './TagsList.module.scss';

export interface TagsListProps {
  tags: readonly SvpTag[];
  className?: string;
}

export const TagsList: VFC<TagsListProps> = ({ tags: tagsProp, className }) => {
  const tags = useMemo(
    () =>
      tagsProp.filter((t) => !RESTRICTED_TAGS[config.provider].includes(t.id)),
    [tagsProp]
  );

  const tagsList = useMemo(() => {
    // For AB link to the main site instead
    if (config.provider === Provider.AB) {
      return tags.map((tag, index) => (
        <Tag
          component="a"
          href={`https://aftonbladet.se/tagg/${getSlug(tag.tag!, Provider.AB)}`}
          key={index}
          className={styles.tag}
        >
          {tag.tag}
        </Tag>
      ));
    }

    return tags.map((tag) => (
      <Link
        key={tag.id}
        to={getPath(routeNames.tag, { tagId: tag.id, title: tag.tag })}
        className={styles.tag}
      >
        <Tag component="span">{tag.tag}</Tag>
      </Link>
    ));
  }, [tags]);

  return (
    <div className={classNames(styles.tagsList, className)}>{tagsList}</div>
  );
};
